export const CLIENT_ID = '197177864748-ko5pm24qv7bk5qvte1qas6njj9fp5gae.apps.googleusercontent.com'
export const PROMPT_PARENT_ID = 'google-one-tap-container'